"use strict";

const React = window.React;
const ReactDOM = window.ReactDOM;
import App from '../react/App.jsx';

document.addEventListener('bb-lumeris:lum-member-vimeo-modal:init', (event) => {
    setTimeout(() => { new MemberVimeoModal(event.detail); }, 1000);
});

class MemberVimeoModal {
    #data;
    #initialized = false;
    #isMarketAllowed = true;
  
    module;
    app;
    triggerSelector;
  
    constructor(data) {
        this.#data = data;
  
        if (!data) {
            return;
        }

        if (this.#data?.settings?.markets?.length > 0 && !this.#data.settings.markets.includes('')) {
            this.isMarketAllowed = false;
        }
  
        this.module = document.querySelector(`[data-node="${data.node}"]`);
        this.app = document.getElementById(`app-${data.node}`);

        this.triggerSelector = `[data-lumeris-member-vimeo-modal="${this.data.settings.modalId}"]`;

        if (!this.app) {
            this.app = document.createElement('div');
            this.app.id = `app-${data.node}`;
            document.body.appendChild(this.app);
        }

        this.bind();
    }

    bind() {
        document.addEventListener('lum-member-event-registration:setSearch', this.onSetSearch);
        document.addEventListener('mouseover', this.onDocumentMouseover);
        document.addEventListener('click', this.onDocumentClick);
    }

    get data() {
        return this.#data;
    }

    get initialized() {
        return this.#initialized;
    }

    get isMarketAllowed() {
        return this.#isMarketAllowed;
    }

    set initialized(val) {
        this.#initialized = val;
    }

    set isMarketAllowed(val) {
        this.#isMarketAllowed = val;
    }

    init(args = {}) {
        if (this.initialized) {
            return;
        }

        this.initialized = true;

        // Remove interaction and search listeners now that initialization is complete
        document.removeEventListener('lum-member-event-registration:setSearch', this.onSetSearch);
        document.removeEventListener('mouseover', this.onDocumentMouseover);
        document.removeEventListener('click', this.onDocumentClick);

        this.app._reactRoot = this.app._reactRoot ?? ReactDOM.createRoot(this.app);

        this.app._reactRoot.render(React.createElement(App, {
            moduleElement: this.module,
            data: this.data,
            triggerSelector: this.triggerSelector ?? null,
            activeTrigger: args?.activeTrigger ?? null,
            openNow: args?.openNow ?? false
        }));
    }

    onSetSearch = (event) => {
        if (event instanceof Object === false) {
			return;
		}

        const newSearch = event.detail?.newSearch ?? null;

        if (!newSearch || !newSearch?.market) {
            return;
        }
        
        const markets = this.data.settings.markets;

        if (!markets || markets.includes(newSearch.market) || markets.includes('')) {
            this.isMarketAllowed = true;
        } else {
            this.isMarketAllowed = false;
        }
    }

    onDocumentClick = (event) => {

        if (this.initialized || !this.isMarketAllowed) {
            return;
        }

        const trigger = event.target.closest(this.triggerSelector);

        if (!trigger) {
            return;
        }

        event.preventDefault();

        this.init({ activeTrigger: trigger, openNow: true });
    }

    onDocumentMouseover = (event) => {
        if (this.initialized || !this.isMarketAllowed) {
            return;
        }

        const trigger = event.target.closest(this.triggerSelector);

        if (!trigger) {
            return;
        }

        this.init();
    }
}